module.exports = __webpack_public_path__ + "static/media/wave.4be59336.svg";